const TOKEN_KEY = 'tsrCustomerToken';

export const getTsrCustomerToken = () => sessionStorage.getItem(TOKEN_KEY) || '';

export const setTsrCustomerToken = (token) => {
  if (token) {
    sessionStorage.setItem(TOKEN_KEY, token);
  } else {
    sessionStorage.removeItem(TOKEN_KEY);
  }
};

export const clearTsrCustomerToken = () => sessionStorage.removeItem(TOKEN_KEY);
